"use client";

import { useForm } from "react-hook-form";
import apiClient from "@/libs/api";
import { toast } from "react-hot-toast";
import { useRouter } from "next/navigation";

type FormData = {
  email: string;
};

export default function UnsubscribePage() {
  const router = useRouter();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>();

  const onSubmit = async (data: FormData) => {
    try {
      await apiClient.post("/unsubscribe", {
        type: "email",
        value: data.email,
      });

      toast.success("Successfully unsubscribed from our emails");

      // Redirect to homepage after 1 second
      setTimeout(() => {
        router.push("/");
      }, 1000);
    } catch (error) {
      // Error handling is already managed by the apiClient interceptor
      console.error("Failed to unsubscribe:", error);
    }
  };

  return (
    <main className="min-h-screen p-8 max-w-2xl mx-auto">
      <h1 className="text-3xl font-bold mb-6">Unsubscribe from Our Emails</h1>

      <div className="mb-8">
        <p className="mb-4">
          We're sorry to see you go. Enter your email address below to
          unsubscribe from our communications.
        </p>
        <p className="mb-4">
          Please note that it may take up to 48 hours for this change to take
          effect.
        </p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <div>
          <label htmlFor="email" className="block text-sm font-medium mb-2">
            Email Address
          </label>
          <input
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "Invalid email address",
              },
            })}
            type="email"
            id="email"
            placeholder="Enter your email address"
            className="w-full px-4 py-2 border rounded-md"
            autoComplete="off"
          />
          {errors.email && (
            <p className="text-red-500 text-sm mt-1">{errors.email.message}</p>
          )}
        </div>

        <button
          type="submit"
          className="bg-red-600 text-white px-6 py-2 rounded-md hover:bg-red-700 transition-colors"
        >
          Unsubscribe
        </button>
      </form>
    </main>
  );
}
